// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__a5SwZ","rootSmall":"AddTileButton_rootSmall__2oSZh"};